import moment from 'moment';
import * as React from 'react';
type Props = {
  date: string;
};
export default (props: Props) => {
  const { date } = props;
  const momentDate = moment(date);
  return <>{momentDate.format('MMMM D YYYY')}</>;
};
